import { Tables } from '../../component/table'
import { useMemo } from 'react'
import { KTCard, toAbsoluteUrl } from '../../../_metronic/helpers'
import { LedgerWrapper } from './user-ledger'
import { useQueryResponseCount } from '../../component/response'
import { getProjectByLocal } from '../projectData'

/**
 * CustomerTableHeader
 * Renders the header for the user ledger table, displays product and balance summary.
 */
const CustomerTableHeader = () => {
    const count = useQueryResponseCount()
    const project = getProjectByLocal()

    return <><div className='d-flex justify-content-between'>
        <div>
            <div className="mb-2">

                <button
                    type="button"
                    className="btn btn-link p-0 fs-4 fw-semibold mb-1 text-gray-900 text-hover-primary"
                    aria-label={project?.product_name}
                >
                    {project?.product_name}
                </button>
            </div>
            <div className="fs-6 fw-semibold text-gray-600 mb-5">Below are your cashback details.</div>
        </div>
        <img
            className="w-50px"
            src={toAbsoluteUrl(`/media/images/${project?.product_img}`)}
            alt=""
        />
    </div>


        <div className='d-flex gap-4'>

            <div className="d-flex align-items-center">
                <div className="symbol symbol-30px symbol-circle me-3">
                    <span style={{ background: '#71ae8d' }} className="symbol-label">
                        <span className="svg-icon svg-icon-5 svg-icon-white">

                            <i className="bi bi-wallet-fill text-white"></i>
                        </span>
                    </span>
                </div>
                <div className="m-0">
                    <span className="fw-semibold text-gray-400 d-block fs-6">Balance</span>
                    <span className="fw-semibold text-gray-800 fs-5">{count?.totalBalance ? count?.totalBalance : '0.00'}</span>
                </div>
            </div>
            <div className="d-flex align-items-center">
                <div className="symbol symbol-30px symbol-circle me-3">
                    <span style={{ background: '#8c63e2' }} className="symbol-label">
                        <span className="svg-icon svg-icon-5 svg-icon-white">

                            <i className="bi bi-wallet-fill text-white"></i>
                        </span>
                    </span>
                </div>
                <div className="m-0">
                    <span className="fw-semibold text-gray-400 d-block fs-6">Credit</span>
                    <span className="fw-semibold text-gray-800 fs-5">{count?.credit ? count?.credit : '0.00'}</span>
                </div>
            </div>
            <div className="d-flex align-items-center">
                <div className="symbol symbol-30px symbol-circle me-3">
                    <span style={{ background: '#c24866' }} className="symbol-label ">
                        <span className="svg-icon svg-icon-5 svg-icon-white">

                            <i className="bi bi-credit-card-fill text-white"></i>
                        </span>
                    </span>
                </div>
                <div className="m-0">
                    <span className="fw-semibold text-gray-400 d-block fs-6">Debit</span>
                    <span className="fw-semibold text-gray-800 fs-5">{count?.debit ? count?.debit : '0.00'}</span>
                </div>
            </div>
            {/* <span className="badge badge-light-danger p-5 me-4 fs-6 text-dark fw-semibolder">Balance:
                {isLoading ? <span className="spinner-grow spinner-grow-sm text-primary" role="status" aria-hidden="true" > </span > : <span className='text-dark fw-semibold'>{count?.totalBalance ? count?.totalBalance : '0.00'}</span>}
            </span>
            <span className="badge badge-light-success p-5 me-4 fs-6 text-dark fw-semibolder"> Credit : {isLoading ? <span className="spinner-grow spinner-grow-sm text-primary" role="status" aria-hidden="true" > </span > : <span className='text-dark fw-semibold'>{count?.credit ? count?.credit : '0.00'}</span>}</span>
            <span className="badge badge-light p-5 me-4 fs-6 text-dark fw-semibolder"> Debit: {isLoading ? <span className="spinner-grow spinner-grow-sm text-primary" role="status" aria-hidden="true" > </span > : <span className='text-dark fw-semibold'>{count?.debit ? count?.debit : '0.00'}</span>}</span>
        */}
        </div >
    </>

}

/**
 * UserLedgerList
 * Displays the user's ledger list in a table format.
 */
const UserLedgerList = () => {


    const columns = useMemo(
        () => [
            {
                Header: (props) => {
                    return <th {...props.column.getHeaderProps()} >
                        <div className="d-flex flex-column">
                            <span className=""> Date </span>
                            <span className="">Txn No.</span>
                        </div>

                    </th>
                },
                id: 'created_at',
                Cell: ({ row }) => {
                    return (
                        <>
                            <div className="blue">{row.original.date} {row.original.time}</div>
                            <div className="blue  text-danger text-capitalize">{row.original.trx_number}</div>
                            <div className="fw-semibolder fs-7 text-gray-700 text-muted text-capitalize">{row.original.description}</div>
                        </>
                    );
                },
            },

            {
                Header: 'Credit',
                accessor: 'credit',
                Cell: ({ row }) => {
                    return (
                        <>
                            <div className="blue text-success"> {row.original.credit ? row.original.credit : '--'}</div>

                        </>
                    );
                },
            },
            {
                Header: 'Debit',
                accessor: 'debit',
                Cell: ({ row }) => {
                    return (
                        <>
                            <div className="blue text-danger">

                                {row.original.debit ? row.original.debit : '--'}
                            </div>

                        </>
                    );
                },
            },
            {
                Header: 'Balance',
                id: 'balnce',
                Cell: ({ row }) => {
                    return (
                        <>
                            <div className="blue"> {row.original.balance ? row.original.balance : '--'}</div>

                        </>
                    );
                },
            },
            // {
            //     Header: 'Action',
            //     id: 'actions',
            //     Cell: ({ ...props }) => <UserActionsCell
            //         action={["View"]}
            //         items={props.data[props.row.index]}
            //         id={props.data[props.row.index].id}
            //         link={'/apps/company-management/user/ledger/view/' + props.data[props.row.index].id}
            //     />,
            // },
        ],
        []
    )

    return <LedgerWrapper>
        <div className='container-fluid mt-3'>
            <KTCard>
                <CustomerTableHeader />
                <Tables columns={columns} />
            </KTCard>
        </div>
    </LedgerWrapper>
}



export { UserLedgerList }